var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultSavedQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292 177h16v15h-16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292 177h16v15h-16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292 177h16v15h-16z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.21587 0 0 1.21587 -354.256 -213.797)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#4285f4",
      InkscapeStroke: "none"
    },
    d: "M14.65 7.64c0-.614-.05-1.063-.158-1.528H7.474v2.774h4.12c-.084.69-.532 1.727-1.529 2.425l-.014.093 2.22 1.719.153.015c1.412-1.304 2.226-3.222 2.226-5.498",
    transform: "matrix(1.06667 0 0 1 292.183 177)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#34a853",
      InkscapeStroke: "none"
    },
    d: "M7.474 14.948c2.018 0 3.712-.664 4.95-1.81l-2.359-1.827c-.63.44-1.478.747-2.59.747-1.977 0-3.655-1.303-4.253-3.106l-.087.008-2.308 1.785-.03.084a7.469 7.469 0 0 0 6.677 4.12",
    transform: "matrix(1.06667 0 0 1 292.183 177)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#fbbc05",
      InkscapeStroke: "none"
    },
    d: "M3.222 8.952a4.602 4.602 0 0 1-.249-1.478c0-.515.091-1.013.24-1.478l-.003-.1L.874 4.084l-.077.036A7.481 7.481 0 0 0 0 7.474c0 1.204.29 2.342.797 3.355l2.425-1.877",
    transform: "matrix(1.06667 0 0 1 292.183 177)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#eb4335",
      InkscapeStroke: "none"
    },
    d: "M7.474 2.89c1.404 0 2.35.606 2.89 1.113l2.11-2.06C11.178.74 9.492 0 7.474 0A7.469 7.469 0 0 0 .797 4.12l2.417 1.876C3.82 4.194 5.498 2.89 7.474 2.89",
    transform: "matrix(1.06667 0 0 1 292.183 177)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultSavedQuery);
export default __webpack_public_path__ + "static/media/vaultSavedQuery.1024cd404b81e92a74d602508617f1d5.svg";
export { ForwardRef as ReactComponent };